import React from 'react';
import FormTextField from '../../../../components/form/text-field';
import SelectField from '../../../../components/form/select-field/select-field';
import SSMFieldWrapper from '../../../ssm-homepage/ssm-components/ssm-field-wrapper/ssm-field-wrapper';
import './customer-details.css';

const CustomerDetails = (props) => {
  const {
    formFields,
    formFieldsIds,
    formFieldsState,
    handleOnBlur,
    handleOnChange,
    formFieldsErrors,
  } = props;

  const fieldWrapperConfiguration = {
    authorableContent: formFields,
    state: formFieldsState,
    onBlurFunction: handleOnBlur,
    onChangeFunction: handleOnChange,
    hasErrors: formFieldsErrors,
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.companyTradingName}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.abnAndAcn}
            customClass="block-spacer"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.streetAddress}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-2 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.suburb}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-2 col-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={SelectField}
            id={formFieldsIds.state}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-2 col-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.postcode}
            customClass="block-spacer"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.firstName}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.lastName}
            customClass="block-spacer"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.billOrAccountNumber}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.adminEmailAdress}
            customClass="block-spacer"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.contactPhoneNumber}
            customClass="block-spacer"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomerDetails;
